import React__default from 'react';
import classnames from 'classnames';
import styles from './Chip.module.css.js';

function Chip({ children, id, type, size }) {
    const className = classnames(styles.Chip, {
        [styles[`Chip__${type}`]]: type,
        [styles[`Chip__${size}`]]: size,
    });
    const attributes = {
        id,
        className,
    };
    return (React__default.createElement("div", { role: "status", ...attributes }, children));
}

export { Chip };
//# sourceMappingURL=Chip.js.map
